

/**
 * @name AlertMessages
 * @description Service to push and retrieve global system alerts
 * @param {Unknown} _ Lodash services
 * @return {object} Returns the AlertMessages object
 */
function AlertMessages(
  _
) {
  let AlertMessages = {};
  AlertMessages.list = [];
  AlertMessages.add = function(alert) {
    let _alert = {
      msg: `Something went wrong. Contact us so we can prevent this error in
      the future.`,
      type: alert.type
    };

    if (_.isString(alert.msg)) {
      _alert.msg = alert.msg;
    } else if (!_.isUndefined(alert.msg) && alert.msg.data &&
    alert.msg.data !== null) {
      _alert.msg = alert.msg.data;
    } else if (!_.isUndefined(alert.msg) &&
        !_.isUndefined(alert.msg.message)) {
      _alert.msg = alert.msg.message;
    } else if (!_.isUndefined(alert.msg) &&
        !_.isUndefined(alert.msg.status) && alert.msg.status === 500) {
      _alert.msg = `Something went wrong. Contact us so we can prevent this
      error in the future.`;
    } else if (!_.isUndefined(alert.msg) && alert.msg.data === null) {
      _alert.msg = `Could not connect to Ink Finder. Please check
      your internet connection.`;
    }
    AlertMessages.list.push(_alert);
  };
  AlertMessages.close = function(index) {
    AlertMessages.list.splice(index, 1);
  };
  return AlertMessages;
}
angular
  .module('inkfinder')
  .factory('AlertMessages', AlertMessages);



// WEBPACK FOOTER //
// ./components/alerts/alert-messages.service.js